<template>
  <div>
    <div
      v-if="showPopup"
      class="floating-btn h-28 lg:h-16 w-3/5 lg:w-1/5 items-center flex justify-center fixed text-sm rounded-lg cursor-pointer"
    >
      <div
        class="flex"
        @click="
          emailPopup = true;
          showPopup = false;
        "
      >
        <img
          class="image-height"
          src="/images/buyalolaccount/icon-essence.png"
          alt="icon"
        />
        <p class="lg:ml-2">
          Free guide on “How to reach Diamond” and “How to Jungle!”
        </p>
      </div>

      <img
        class="mb-16 mr-2 md:mb-10"
        src="/images/blog/x.png"
        alt="icon"
        @click="showPopup = false"
      />
    </div>

    <div v-if="emailPopup">
      <div
        :class="[
          'email-popup lg:w-1/4 items-center justify-center fixed mr-2 rounded-lg',
          `${showEmailPopup ? 'lol-giveaway-position' : ''}`,
        ]"
      >
        <div class="relative">
          <img src="/images/blog/popup.jpg" alt="icon" />
          <i
            class="fa fa-times absolute mt-6 cursor-pointer image-left"
            aria-hidden="true"
            @click="displayPopup()"
          />
        </div>
        <div class="font-bold text-4xl ml-4">
          Would you like to climb to Diamond? Or learn how to Jungle? We have a
          special offer for you.
        </div>
        <div class="ml-4 text-sm mt-2">
          <span class="font-bold text-smurfs-gold"
          >Subscribe to our newsletter</span
          >
          and you will receive a guide “How to reach diamond” with rank and role
          specific tips as well as a completely separate throughout
          <span class="font-bold text-smurfs-gold">“Jungle guide”</span>.
        </div>
        <input
          v-model="name"
          class="ml-4 mt-2 outline-none popup-input-fields"
          type="text"
          placeholder="Your Name"
        />
        <input
          v-model.trim="email"
          class="ml-4 mt-2 outline-none popup-input-fields"
          name="email"
          type="text"
          placeholder="Your Email"
        />
        <div class="ml-4 text-sm mt-2 p-1">
          Want to hear something better? For as long as you stay subscribed your
          email will be counted as an entry for our
          <span class="font-bold text-smurfs-gold"
          >monthly Diamond smurfs and rare skin smurfs giveaways each
            month!</span
          >
        </div>
        <div
          :class="[
            'mt-2 py-2 text-center',
            canSubscribe
              ? 'text-absolute-white bg-smurfs-gold cursor-pointer'
              : 'text-60 bg-metallic-grey cursor-not-allowed',
          ]"
          @click="handleSubscription"
        >
          {{ subscribeButtonText }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import emailValidator from 'email-validator';
import { sha256 } from 'js-sha256';

export default {
  props: {
    showEmailPopup: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      subscribeButtonText: 'SUBSCRIBE',
      showPopup: false,
      emailPopup: false,
      name: '',
      email: '',
    };
  },

  computed: {
    canSubscribe() {
      return (
        this.name !== '' &&
        this.email !== '' &&
        this.subscribeButtonText !== 'SUBSCRIBED' &&
        emailValidator.validate(this.email)
      );
    },
  },

  mounted() {
    this.setTimeOut();
  },

  methods: {
    setTimeOut() {
      setTimeout(() => {
        if (this.showEmailPopup) {
          this.emailPopup = true;
        } else {
          this.showPopup = true;
        }
      }, 1000);
    },

    displayPopup() {
      if (this.showEmailPopup) {
        document.getElementById('show-floating-button').style.display = 'none';
      } else {
        this.emailPopup = false;
        this.showPopup = true;
      }
    },

    handleSubscription() {
      this.subscribeButtonText = 'SUBSCRIBED';

      if (window.dataLayer) {
        dataLayer.push({
          event: 'userSubscription',
          subscription: {
            add: {
              user: {
                name: this.name,
                email: this.email,
                externalId: sha256(this.email),
              },
            },
          },
        });
      }
    },
  },
};
</script>
